import Banner from '../comps/Banner';
import Highlights from '../compsCN/Highlights';
import ListA from '../compsJp/ListA';
import ListB from '../compsCN/ListB';
import SectionA from '../compsJp/SectionA';
import SectionB from '../compsJp/SectionB';
import SectionC from '../compsCN/SectionC';
import SectionD from '../compsJp/SectionD';
import SectionE from '../compsJp/SectionE';
import SectionF from '../compsJp/SectionF';
import TabA from '../compsJp/TabA';
import WhatInBox from '../compsJp/WhatInBox';
import FootTC from '../compsCN/FootTC';
import styles from './ProductContent.module.scss';

export default function ProductCN({ bundles, callbackCart }: any) {
    return (
        <div className={styles.cnPage}>
            <Banner />
            <Highlights />
            <SectionA />
            <SectionB />
            <SectionC />
            <SectionD />
            <SectionE />
            <TabA />
            <SectionF />
            <ListA />
            <ListB />
            <WhatInBox />
            <FootTC />
        </div>
    );
}
